module.exports = __webpack_public_path__ + "media/images/login-f8f176a218f8bbfa86942fcb48c5ab72.jpg";